
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var par = require("par");
var xtend = require("xtend");

module.exports = Model({
	name: "managedmanageroutgoingrequests",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_people: [],
	_requests: [],
	_managee: null,
	track: track,
	refresh: refresh,
	recalculate: recalculate
});

function init() {
	this._who_tracker = this.dispatcher.createTracker();
	this.push([]);
}

function uninit() {
	this.tracker.off();
	this.push([]);
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"people:updated": handle_people_update
	};
}

function triggers() {
	return {
		"view": view
	};
}

function view(data) {
	var managee = data.managee;
	const group = data.group;
	this._managee = managee;
	this._group = group;
	this.track(managee);
	this.refresh(managee);
}

function track(managee) {

	if (!managee) {
		console.log("Must provide managee and manager");
		return;
	}

	// Create a tracker for the managee's outgoing requests and their status
	var tracker = this._who_tracker;
	var group = this._group;

	tracker.off();

	if(group) {
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/manage/request/out/new", par(refresh.bind(this), managee));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/manage/request/out/accepted", par(refresh.bind(this), managee));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/manage/request/out/denied", par(refresh.bind(this), managee));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/manage/request/out/cancelled", par(refresh.bind(this), managee));
	} else {
		tracker.on("mqtt:u/" + managee + "/manage/request/out/new", par(refresh.bind(this), managee));
		tracker.on("mqtt:u/" + managee + "/manage/request/out/accepted", par(refresh.bind(this), managee));
		tracker.on("mqtt:u/" + managee + "/manage/request/out/denied", par(refresh.bind(this), managee));
		tracker.on("mqtt:u/" + managee + "/manage/request/out/cancelled", par(refresh.bind(this), managee));
	}
}

function handle_people_update(people) {
	this._people = people;
	this.recalculate();
}

//  Replaces 'id' numbers with public info (fname, lname, etc)
function recalculate() {
	var people = this._people;
	var requests = this._requests;
	if (!requests || !people) return;

	var merge = requests.map(function (request) {
		return xtend(request, {
			to: people[request.to]
		});
	});
	this.push(merge);
}

function refresh(managee) {
	if (!managee && !this._managee) return;
	if (!managee) managee = this._managee;
	const group = this._group;

	return this.api.manage.manage.request.list(managee, group)
		.then(set_people.bind(this))
		.then(do_update.bind(this))
		.catch(console.error.bind(console));
}

// Extracts the id's of all the 'request.to' emits to 'people' model to add them
// to the list of 'watched' people
function set_people(requests) {
	var managers = requests.map(function (request) {
		return request.to;
	});
	this.emit("people:trigger:add", {
		who: managers,
		lean: true
	});
	return requests;
}

function do_update(requests) {
	if (!requests.length && this._requests.length) {
		this._requests = [];
		this.push([]);
		return;
	}

	this._requests = requests;
	this.recalculate();
}
